module.exports = __webpack_public_path__ + "img/Sent.a0456149.svg";